import { render, staticRenderFns } from "./repository.vue?vue&type=template&id=8c3cc938&scoped=true"
import script from "./repository.vue?vue&type=script&lang=js"
export * from "./repository.vue?vue&type=script&lang=js"
import style0 from "./repository.vue?vue&type=style&index=0&id=8c3cc938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3cc938",
  null
  
)

export default component.exports